// path consts
// general paths
export const PATH_SUCCESS = '/success';
export const PATH_ERROR = '/fatal-error';

// modal name list
export const MODAL_ACCOUNT = 'accountModal';
export const MODAL_EMAIL_VERIFICATION = 'emailVerificationModal';

// modal child variation list
export const MODAL_VARIATION_EXISTING_USER_NO_RA = 'existingUserNoRa';
export const MODAL_VARIATION_EXISTING_USER_MOBILE_ADDON = 'existingUserMobileAddOn';
export const MODAL_VARIATION_TOUCH = 'touch';
export const MODAL_VARIATION_RETRIAL = 'retrial';
export const MODAL_VARIATION_ERROR = 'error';

// store name list
export const STORE_TRIAL = 'trialStore';
export const STORE_MOBILE_TRIAL = 'mobileTrialStore';

// COG error list
export const COG_ERROR_TOUCH = 'TOUCH_USER';
export const COG_ERROR_EXISTING_USER_NO_RA = 'EXISTING_USER_NO_RA';
export const COG_ERROR_EXISTING_USER_MOBILE = 'EXISTING_USER_MOBILE';
export const COG_ERROR_EXISTING_USER_REQUIRED = 'EXISTING_USER_REQUIRED';
